import { HumanizeDurationOptions } from "humanize-duration-ts";
import { useMemo } from "react";

import { DateTime } from "@bps/date-time";
import { Text, useFormContext } from "@bps/fluent-ui";
import { getHumanizedTimeRelativeToNow } from "@libs/common/common.utils";

import { convertToDateTime } from "../utils";
import { RolloutFormValues } from "./rolloutFormValues";

export const RolloutCommencesLabel: React.FC = () => {
  const { state } = useFormContext<RolloutFormValues>();

  const commencesLabel = useMemo(() => {
    const humanizeOptions = {
      units: ["d", "h", "m"],
      round: true
    } as HumanizeDurationOptions;

    return (
      state.values.initialDownloadDateStartUtc &&
      state.values.initialDownloadTimeStartUtc &&
      getHumanizedTimeRelativeToNow(
        convertToDateTime(
          state.values.initialDownloadDateStartUtc!,
          state.values.initialDownloadTimeStartUtc!
        ),
        DateTime.now().setZone("utc"),
        humanizeOptions
      )
    );
  }, [
    state.values.initialDownloadDateStartUtc,
    state.values.initialDownloadTimeStartUtc
  ]);

  if (!commencesLabel) return null;

  return <Text variant="xSmall">{commencesLabel}</Text>;
};
